export const translations = {
  fr: {
    meta: {
      label: 'Français',
      dir: 'ltr',
      locale: 'fr-FR',
      flag: '🇫🇷',
      flagImage: '/flags/fr.svg'
    },
    header: {
      nav: {
        shipTrackQuote: 'Expedier, suivre, devis',
        getQuote: 'Obtenir un devis',
        services: 'Services',
        consulting: 'Transports - conseils et services',
        road: 'Transports routiers (entreprises)',
        careers: 'Carrieres',
        company: 'Entreprise',
        about: 'A propos',
        contact: 'Contact',
        cta: 'Demander un devis →'
      },
      searchLabel: 'Rechercher',
      languageLabel: 'Langue'
    },
    logo: {
      ariaLabel: 'Transport Logistique',
      alt: 'Transport Logistique'
    },
    home: {
      hero: {
        tagline: 'logistique premium',
        heading: 'Votre fret avant tout',
        subheading: "Nous sommes un leader du fret LTL avec un reseau, une technologie et un service de premier plan. Notre plateforme simplifie les expeditions et propose des devis instantanes pour des livraisons sures et rapides.",
        ctaPrimary: 'Obtenir un devis gratuit',
        ctaSecondary: 'Contacter notre equipe',
        metrics: [
          { value: '24/7', label: 'Operations sur le continent' },
          { value: '98%', label: 'Livraisons ponctuelles' },
          { value: '50+', label: 'Clients partenaires actifs' }
        ]
      },
      services: {
        heading: 'Nos services de transport',
        intro: "Des solutions multimodales concues pour securiser, accelerer et suivre chacune de vos expeditions. Choisissez l'offre qui correspond a vos flux et laissez nos equipes orchestrer chaque trajet.",
        items: [
          {
            title: 'Transports - conseils et services',
            tag: 'expertise',
            description: 'Des equipes dediees pour orchestrer vos operations, optimiser vos couts et garantir la conformite douaniere.',
            highlights: [
              'Commissionnaires agrees en transports',
              'Services au sol pour compagnies aeriennes',
              'Shipchandlers'
            ],
            linkLabel: "Decouvrir l'accompagnement"
          },
          {
            title: 'Transports routiers (entreprises)',
            tag: 'operations',
            description: 'Des solutions routieres fiables et flexibles pour soutenir vos flux quotidiens et internationaux.',
            highlights: [
              'Transports routiers de marchandises',
              'Transports urbains',
              'Transports internationaux TIR',
              'Transports scolaires'
            ],
            linkLabel: 'Explorer nos services routiers'
          }
        ]
      },
      features: {
        tag: 'AVANTAGES',
        title: 'Pourquoi choisir nos services de transport',
        description: "Une offre integree qui combine expertise douaniere, presence aeroportuaire, couverture routiere et mobilite des personnes. Chaque visuel illustre un pilier cle coordonne par nos equipes dediees.",
        controls: {
          prev: 'Slide precedent',
          next: 'Slide suivant',
          indicatorPrefix: 'Aller a'
        },
        cards: [
          {
            title: 'Pilotage douanier certifie',
            description: 'Commissionnaires agrees, conformite documentaire et suivi proactif pour fluidifier chaque passage de frontiere.',
            tag: 'Conformite'
          },
          {
            title: 'Operations aeroportuaires',
            description: 'Coordination handling, services au sol et intendance a quai pour soutenir vos rotations aeriennes.',
            tag: 'Aerien'
          },
          {
            title: 'Reseau routier agile',
            description: 'Solutions marchandises, urbain et TIR international pour des flux routiers fiables et flexibles.',
            tag: 'Routier'
          },
          {
            title: 'Mobilite communautaire',
            description: 'Transports scolaires et navettes locales assures par des conducteurs verifies et equipes modernes.',
            tag: 'Mobilite'
          }
        ]
      },
      metrics: {
        title: 'Nos chiffres clefs',
        intro: "Un reseau structure autour de la performance operationnelle, de la securite cargo et d'une approche responsable. Ces indicateurs synthetisent les garanties offertes a nos chargeurs sur tous les axes d'activite.",
        stats: [
          {
            value: '98%',
            label: 'Livraisons ponctuelles',
            description: 'Taux de ponctualite annuel garanti par un reseau de conducteurs et partenaires verifies.'
          },
          {
            value: '0 incident majeur',
            label: 'Securite du fret',
            description: 'Protocoles proactifs et chaines de controle digitalisees pour proteger vos marchandises sensibles.'
          },
          {
            value: '30 min',
            label: 'Temps moyen de reponse',
            description: 'Support operations disponible 24/7 avec un centre de coordination dedie par axe logistique.'
          },
          {
            value: '-18%',
            label: 'Empreinte carbone',
            description: 'Programme de modernisation de flotte et compensation carbone pour des corridors plus durables.'
          }
        ],
        milestones: [
          {
            year: '1998',
            title: 'Lancement de notre hub principal',
            description: 'Ouverture du premier terminal multi-modal reliant nord et sud du pays avec suivi centralise.'
          },
          {
            year: '2008',
            title: 'Accreditation douaniere',
            description: 'Obtention des certifications OEA et C-TPAT pour simplifier vos formalites frontaliere.'
          },
          {
            year: '2016',
            title: 'Plateforme de visibilite unifiee',
            description: "Deploiement d'un portail client integrant suivi temps reel, devis et analyse de performance."
          },
          {
            year: '2023',
            title: 'Engagement energie propre',
            description: 'Conversion de 40 % de la flotte a des solutions hybrides et electriques sur les corridors courts.'
          }
        ]
      },
      cta: {
        title: 'Pret a optimiser vos expeditions ?',
        description: "Rejoignez des milliers d'entreprises qui font confiance a nos services de transport pour des solutions fiables, efficaces et economiques. Commencez des maintenant pour decouvrir la difference que notre expertise logistique peut apporter.",
        primary: 'Obtenir un devis gratuit',
        secondary: 'Contacter notre equipe'
      }
    },
    footer: {
      intro: "Votre partenaire de confiance pour le transport et la logistique. Nous offrons des solutions d'expedition efficaces aux entreprises de toutes tailles a travers le pays et a l'international.",
      quickLinks: {
        title: 'Liens rapides',
        items: [
          { label: 'Accueil', to: '/' },
          { label: 'Services', to: '/services' },
          { label: 'Suivre un envoi', to: '/tracking' },
          { label: 'Obtenir un devis', to: '/quote' },
          { label: 'Carrieres', to: '/careers' },
          { label: 'A propos', to: '/about' }
        ]
      },
      services: {
        title: 'Nos services',
        items: [
          { label: 'Fret LTL', to: '/services/ltl' },
          { label: 'Chargement complet', to: '/services/ftl' },
          { label: 'Transport international', to: '/services/international' },
          { label: 'Livraison express', to: '/services/expedited' },
          { label: 'Entreposage', to: '/services/warehousing' },
          { label: 'Gestion logistique', to: '/services/logistics' }
        ]
      },
      contact: {
        title: 'Nous contacter',
        address: '4 OP GH1 CHAMPS DU PRINTEMPS ETG 4 APPT 10 IMM D, Province de Casablanca, Casablanca, Maroc'
      },
      bottom: {
        rights: 'Tous droits reserves.',
        terms: 'Conditions generales',
        privacy: 'Politique de confidentialite'
      }
    },
    pages: {
      services: {
        tag: 'solutions 360',
        title: 'Des services adaptes a votre chaine logistique',
        intro: "Des palettes uniques aux programmes logistiques d'envergure, nos experts du transport livrent des solutions qui maintiennent votre fret en mouvement. Decouvrez nos offres principales et voyez comment nos equipes dediees combinent technologie, visibilite et execution fiable pour soutenir vos objectifs d'entreprise.",
        stats: [
          { value: '24/7', label: "Operations sur toute l'Amerique du Nord" },
          { value: '98%', label: "Livraisons ponctuelles l'an dernier" },
          { value: '5 000+', label: 'Expediteurs satisfaits accompagnes chaque annee' },
          { value: '350+', label: 'Partenaires logistiques strategiques dans le monde' }
        ]
      },
      tracking: {
        title: 'Suivez votre envoi',
        intro: "Saisissez votre numero de suivi pour consulter les dernieres mises a jour de nos equipes operations. Nous fournissons des notifications en temps reel a chaque etape du transit.",
        placeholder: 'ex. TRK-4589-2034',
        button: 'Suivre',
        help: "Besoin d'aide ? Ecrivez a tracking@transportcompany.com ou appelez le (800) 123-4567.",
        updatesTitle: 'Dernieres mises a jour',
        updates: [
          {
            title: 'Envoi en transit',
            description: 'Depart du hub regional de Dallas (TX). Arrivee estimee : 2 jours.'
          },
          {
            title: 'Douanes validees',
            description: 'Documents internationaux verifies. Preparation de la derniere livraison.'
          },
          {
            title: 'Preuve de livraison',
            description: 'La signature electronique sera disponible des la remise.'
          }
        ],
        alert: "Suivi de l'envoi numero : {trackingNumber}"
      },
      quote: {
        title: 'Demander un devis de transport',
        intro: "Remplissez le formulaire ci-dessous et obtenez une estimation instantanee du prix de votre transport. Notre equipe validera votre devis et vous enverra le document officiel par email dans les 24 heures.",
        success: '✅ Votre demande de devis a ete envoyee avec succes ! Nous vous contacterons bientot par email avec le devis officiel.',
        errorFallback: 'Une erreur est survenue. Veuillez reessayer.',
        sections: {
          contact: 'Informations de contact',
          transport: 'Details du transport',
          route: 'Itineraire'
        },
        fields: {
          name: 'Nom complet',
          company: 'Societe',
          phone: 'Telephone',
          email: 'Email',
          transportType: 'Type de transport',
          originContinent: 'Continent de depart',
          originCountry: 'Pays de depart',
          originCity: 'Ville de depart',
          destinationContinent: "Continent d'arrivee",
          destinationCountry: "Pays d'arrivee",
          destinationCity: "Ville d'arrivee",
          quantity: 'Quantite',
          unit: 'Unite',
          desiredDate: 'Date souhaitee',
          roundTrip: 'Transport aller-retour',
          comments: 'Commentaires ou exigences particulieres'
        },
        placeholders: {
          name: 'Jean Dupont',
          company: 'Entreprise SARL',
          phone: '+212 6XX-XXXXXX',
          email: 'jean.dupont@example.com',
          quantity: '10',
          comments: "Toute information supplementaire qui pourrait nous aider..."
        },
        selects: {
          selectType: '-- Selectionnez un type --',
          selectContinent: '-- Selectionnez un continent --',
          selectCountry: '-- Selectionnez un pays --',
          selectCity: '-- Selectionnez une ville --'
        },
        units: {
          tonne: 'Tonne',
          m3: 'm3 (metre cube)'
        },
        estimate: {
          label: 'Prix estime (TTC)',
          note: "* Ceci est une estimation. Le prix final sera confirme apres validation par notre equipe."
        },
        calculating: '🔄 Calcul du prix estime en cours...',
        submit: {
          idle: '📨 Obtenir mon devis',
          loading: '⏳ Envoi en cours...'
        },
        disclaimer: "En envoyant ce formulaire, vous acceptez d'etre contacte par notre equipe commerciale. Vos donnees sont protegees et ne seront jamais partagees avec des tiers.",
        transportFallbacks: [
          { id: 'road', label: 'Transport routier' },
          { id: 'sea', label: 'Transport maritime' },
          { id: 'air', label: 'Transport aerien' }
        ]
      },
      careers: {
        tag: 'Pride Trans',
        title: 'Rencontrez notre fondateur et gerant',
        intro: "Hicham El Hammadi a fonde Pride Trans pour apporter une expertise terrain et une proximite client rares sur le marche du transport marocain. Entrepreneur passionne, il pilote chaque projet avec engagement et veille a ce que nos partenaires et nos conducteurs disposent des meilleures conditions pour reussir.",
        quote: "« Chaque mission que nous acceptons est un engagement personnel. Nous voulons que nos clients sentent qu ils ont un partenaire de confiance a leurs cotes, quel que soit le defis logistique. »",
        signatureRole: 'Fondateur & Gerant, Pride Trans',
        portraitAlt: 'Hicham El Hammadi, fondateur de Pride Trans',
        visionTitle: 'Sa vision',
        visionParagraphs: [
          "Apres plus de dix ans passes dans le transport et la logistique, Hicham El Hammadi a construit Pride Trans autour d un principe simple : conjuguer rigueur operatoire et proximite humaine. Il etudie chaque demande client, selectionne les equipes adapteees et deploye une supervision en temps reel pour assurer la securite des conducteurs ainsi que la satisfaction client.",
          "Son leadership favorise une culture d excellence et de responsabilite partagee. Pride Trans investit dans la formation continue, la digitalisation des flux et l entretien de ses vehicules pour garantir des operations fiables sur l ensemble du territoire marocain et a l international."
        ]
      },
      about: {
        title: 'A propos de Transport Company',
        intro: "Nous sommes un transporteur prive offrant un service fiable partout en Amerique du Nord. Nos equipes orchestrent chaque envoi avec precision en combinant une flotte moderne, des terminaux strategiques et des technologies innovantes pour garantir un fret securise et ponctuel.",
        missionTitle: 'Notre mission',
        missionText: "Relier les entreprises a la capacite dont elles ont besoin, au moment opportun. Nous collaborons etroitement avec nos clients pour comprendre leurs chaines logistiques, concevoir des strategies resilientes et executer avec un service irreprochable.",
        valuesTitle: 'Nos valeurs',
        valuesText: "La securite, l'integrite et la responsabilite guident chacune de nos decisions. Nous investissons dans les equipes, la technologie et des pratiques durables afin d'offrir des resultats remarquables aux chargeurs, conducteurs et communautes.",
        milestones: [
          {
            year: '1998',
            text: 'Transport Company lance un terminal unique avec la mission de moderniser le fret regional.'
          },
          {
            year: '2005',
            text: "Extension de la couverture LTL a l'echelle nationale et creation de notre premiere equipe de commissionnaires en douane."
          },
          {
            year: '2014',
            text: "Deploiement d'une plateforme de visibilite cloud avec notifications proactives pour les chargeurs et destinataires."
          },
          {
            year: '2022',
            text: "Ouverture de notre laboratoire d'innovation dedie a la durabilite, a la robotique et a la logistique pilotee par les donnees."
          }
        ]
      },
      contact: {
        tag: 'contact',
        title: 'Parlons de vos operations transport',
        intro: "Notre cellule support est disponible 7j/7 pour suivre vos expeditions, coordonner vos demandes et preparer vos devis. Choisissez le canal qui vous convient ou envoyez-nous directement votre message.",
        directTitle: 'Coordonnees directes',
        directLabels: {
          customerService: 'Service clients',
          dispatch: 'Dispatch operations',
          email: 'Support email'
        },
        locationsTitle: 'Nos implantations',
        locationsIntro: "Nos equipes sont basees au Maroc avec des relais partenaires dans les principaux hubs regionaux. Nous pouvons organiser des rendez-vous physiques ou visio selon vos disponibilites pour auditer vos besoins et lancer un plan d action immediat.",
        locations: [
          {
            title: 'Casablanca',
            text: 'Siege social et cellule de pilotage. Support commercial, suivi transport et coordination douaniere centrale.'
          },
          {
            title: 'Tanger Med',
            text: 'Equipe portuaire dediee aux formalites import/export et au suivi des transports routes et maritimes.'
          },
          {
            title: 'Marrakech',
            text: "Antenne operationnelle pour les missions de distribution regionale et l accompagnement terrain des conducteurs."
          }
        ],
        formTitle: 'Envoyer un message',
        formIntro: 'Partagez vos informations de transport et nous vous recontacterons sous 24 heures ouvrables avec un plan d actions.',
        form: {
          name: 'Nom complet',
          company: 'Entreprise',
          email: 'Adresse email',
          phone: 'Telephone',
          message: 'Comment pouvons-nous vous aider ?'
        },
        placeholders: {
          name: 'Votre nom',
          company: 'Nom de votre entreprise',
          email: 'vous@entreprise.com',
          phone: 'Votre numero',
          message: 'Precisez votre besoin logistique'
        },
        submit: 'Envoyer la demande',
        disclaimer: 'En envoyant ce formulaire, vous acceptez que notre equipe vous contacte par telephone ou email.'
      },
      consulting: {
        tag: 'conseil et pilotage',
        title: 'Des experts transport dedies a votre strategie',
        intro: "Notre equipe conseil coordonne vos dossiers transport, douane et supply chain pour fluidifier les operations, reduire les risques et aligner chaque acteur autour d indicateurs partages. Nous agissons comme l extension de votre direction logistique.",
        highlightTitle: 'Ce que nous assurons',
        highlightText: "Nous mettons en place une gouvernance transport claire avec des processus standardises, des outils digitaux pour suivre les flux et une relation directe avec les autorites et partenaires logistiques.",
        focusList: [
          'Audits de conformite douaniere et fiscale',
          'Gestion documentaire des flux import export',
          'Reingenierie des processus de supply chain',
          'Pilotage des indicateurs de performance logistique'
        ],
        programsTitle: "Programmes d'accompagnement personnalises",
        programsIntro: "Chaque mission demarre par un diagnostic complet de vos flux et de vos outils. Nous construisons ensuite une feuille de route en quatre semaines, ponctuee d ateliers avec vos equipes finance, operations et IT pour prioriser les quick wins et le long terme.",
        pillars: [
          {
            title: 'Bureau de pilotage',
            text: "Nous concevons un centre de controle adapte a votre organisation avec des points d escalation clairs et un reporting decisionnel partage en temps reel."
          },
          {
            title: 'Accompagnement terrain',
            text: 'Nos consultants interviennent sur site pour former vos equipes aux bonnes pratiques transport, digitaliser les procedures et coordonner les partenaires.'
          },
          {
            title: 'Veille et regulation',
            text: "Nous assurons une veille reglementaire permanente et proposons des scenarios d adaptation permettant de securiser vos operations internationales."
          }
        ],
        kpiTitle: 'Indicateurs suivis',
        kpiIntro: "Nous monitorons la performance de vos operations via un cockpit partage avec vos equipes dirigeantes et un reporting automatisable. Ces indicateurs sont ajustes selon vos objectifs de service client, de cout et de durabilite.",
        kpis: [
          { value: '30%', label: 'Reduction moyenne des couts indirects observes' },
          { value: '12h', label: 'Delai standard pour la mise en place d un plan d action' },
          { value: '65+', label: 'Experts mobilisables sur vos filiales et hubs' },
          { value: '100%', label: 'Dossiers auditables documentes en digital' }
        ]
      },
      road: {
        tag: 'transport routier',
        title: 'Des solutions terrain pour vos flux B2B',
        intro: "De la collecte locale aux liaisons internationales, nos equipes routieres assurent un reseau agile et fiable. Nous combinons planification, suivi digital et capacites adaptees pour soutenir vos operations sensibles.",
        metricsTitle: 'Notre difference sur la route',
        metrics: [
          'Routier domestique et transfrontalier 24/7',
          'Flotte hybride et temperature controlable',
          'Dispatch proactif et suivi ETA en temps reel',
          'Conducteurs certifies et formations securite'
        ],
        linesTitle: 'Des lignes de service modulables',
        linesIntro: "Nous configurons nos ressources autour de vos volumes, de vos fenetres de livraison et de vos exigences sectorielles. Chaque contrat est pilote par un responsable de compte qui orchestre conducteurs, affretement et service client.",
        serviceLines: [
          {
            title: 'Messagerie et LTL',
            text: 'Regroupement intelligent des palettes, livraisons precisees, notification automatique et SLA adaptes aux flux B2B.'
          },
          {
            title: 'FTL et projets speciaux',
            text: 'Capacites spot et contrats longue duree, escortes si necessaires et gestion des permis pour charges hors gabarit.'
          },
          {
            title: 'Distribution urbaine',
            text: "Plans de tournees optimises avec vehicules a faibles emissions pour desservir les centres urbains et zones a faibles emissions."
          },
          {
            title: 'Services dedies',
            text: 'Mise a disposition de conducteurs, affretement dedie et integration a vos WMS et TMS pour piloter les ordres en direct.'
          }
        ],
        logisticsTitle: 'Dispositif logistique',
        logisticsIntro: "Nos equipes planifient les trajets en coordination avec votre supply chain et s appuient sur des outils maison pour ajuster les routes en temps reel. Nous couvrons aussi bien les flux regulier que les operations critiques.",
        logistics: [
          {
            title: 'Capacites techniques',
            items: [
              'Remorques mega volume et frigorifiques',
              'Vehicules ADR pour marchandises dangereuses',
              'Racks speciaux pour charges sensibles',
              "Telematique embarquee pour l eco-conduite"
            ]
          },
          {
            title: 'Coordination operatoire',
            items: [
              'Tour de controle 24/7 avec dispatch bilingue',
              'Portal client avec informations ETA et POD',
              'Integration EDI et API avec vos outils',
              'Planification conjointe avec vos chargeurs'
            ]
          },
          {
            title: 'Engagements durables',
            items: [
              'Optimisation des kilometres a vide',
              'Compensation carbone sur demande',
              'Programme conducteur ambassadeur securite',
              'Maintenance preventive et pneus basse resistance'
            ]
          }
        ]
      },
      adminLogin: {
        logo: 'Transport Admin',
        subLogo: "Panneau d'administration",
        title: 'Connexion',
        username: "Nom d'utilisateur",
        password: 'Mot de passe',
        usernamePlaceholder: "Entrez votre nom d'utilisateur",
        passwordPlaceholder: 'Entrez votre mot de passe',
        submitIdle: 'Se connecter',
        submitLoading: 'Connexion...',
        errorEmpty: 'Veuillez remplir tous les champs',
        errorInvalid: 'Identifiants incorrects. Veuillez reessayer.',
        demo: 'Demo',
        demoText: 'Utilisateur: admin / Mot de passe: admin123'
      },
      adminDashboard: {
        logo: 'Transport Admin',
        userLabel: 'Administrateur',
        settings: 'Parametres',
        logout: 'Deconnexion',
        title: 'Tableau de bord',
        subtitle: 'Gerez les demandes de devis de transport',
        stats: {
          total: 'Total des demandes',
          pending: 'En attente',
          processed: 'Traites',
          rejected: 'Rejetes'
        },
        filterLabel: 'Filtrer par statut:',
        filterOptions: {
          all: 'Tous',
          pending: 'En attente',
          processed: 'Traites',
          rejected: 'Rejetes'
        },
        empty: {
          loading: 'Chargement...',
          title: 'Aucune demande de devis',
          subtitle: 'Les demandes de devis apparaitront ici.'
        },
        table: {
          date: 'Date',
          contact: 'Contact',
          email: 'Email',
          route: 'Trajet',
          status: 'Statut',
          actions: 'Actions',
          viewDetails: 'Voir details'
        },
        alerts: {
          updateStatus: 'Erreur lors de la mise a jour du statut',
          deleteConfirm: 'Etes-vous sur de vouloir supprimer cette demande ?',
          deleteError: 'Erreur lors de la suppression'
        },
        statusLabels: {
          pending: 'En attente',
          processed: 'Traite',
          rejected: 'Rejete'
        }
      },
      adminSettings: {
        back: 'Retour au tableau de bord',
        title: 'Parametres systeme',
        save: 'Enregistrer les modifications',
        saving: 'Enregistrement...',
        saved: 'Parametres enregistres avec succes !',
        saveFailed: 'Echec de l\'enregistrement des parametres.',
        loadFailed: 'Echec du chargement des parametres. Utilisation des valeurs par defaut.',
        transportTitle: 'Tarification des types de transport',
        newTypePlaceholder: 'Nouveau type de transport (ex. Rail)',
        addType: '+ Ajouter',
        deleteType: 'Supprimer le type',
        rateKm: 'Tarif au km (MAD)',
        rateTonne: 'Tarif a la tonne (MAD)',
        fixedFees: 'Frais fixes (MAD)',
        europeTitle: 'Parametres Europe',
        europeEnable: 'Activer la tarification speciale pour l\'Europe',
        multiplier: 'Coefficient de prix (1.0 = normal)',
        surcharge: 'Surcharge fixe additionnelle (MAD)',
        africaTitle: 'Parametres Afrique',
        africaEnable: 'Activer la tarification speciale pour l\'Afrique',
        activeCountries: 'Pays africains actifs (selection multiple)',
        selectHint: 'Maintenez Ctrl (Windows) ou Cmd (Mac) pour selectionner plusieurs pays.',
        loading: 'Chargement...'
      }
    },
    modal: {
      quoteDetail: {
        title: 'Devis N°{id}',
        clientInfo: 'Informations Client',
        transportInfo: 'Details du Transport',
        pricingTitle: 'Parametres du Devis (Modifiable)',
        resetRates: 'Reinitialiser avec les tarifs systeme',
        fields: {
          name: 'Nom',
          company: 'Societe',
          email: 'Email',
          phone: 'Telephone',
          status: 'Statut',
          requestDate: 'Date de demande',
          transportType: 'Type de transport',
          origin: 'Depart',
          destination: 'Arrivee',
          distance: 'Distance',
          quantity: 'Quantite',
          desiredDate: 'Date souhaitee',
          roundTrip: 'Aller-retour',
          comments: 'Commentaires',
          distanceKm: 'Distance (km)',
          quantityUnit: 'Quantite ({unit})',
          rateKm: 'Tarif au km (MAD)',
          rateTonne: 'Tarif a la tonne (MAD)',
          fixedFees: 'Frais fixes (MAD)',
          discount: 'Remise (%)',
          vat: 'TVA (%)'
        },
        selectType: 'Selectionner...',
        price: {
          label: 'Prix Final TTC',
          distance: 'Distance ({distance} km x {rate})',
          quantity: 'Quantite ({quantity} x {rate})',
          fixed: 'Frais fixes',
          subtotal: 'Sous-total HT',
          discount: 'Remise ({discount}%)',
          afterDiscount: 'Prix HT apres remise',
          vat: 'TVA ({vat}%)',
          total: 'TOTAL TTC'
        },
        buttons: {
          save: 'Enregistrer modifications',
          reject: 'Refuser devis',
          validate: 'Valider devis (PDF + Email)'
        },
        badges: {
          validated: 'Devis valide le {date}',
          rejected: 'Devis refuse le {date}'
        },
        confirm: {
          validate: 'Valider ce devis et envoyer un email au client ?',
          reject: 'Etes-vous sur de vouloir refuser ce devis ?'
        },
        success: {
          ratesUpdated: 'Tarifs mis a jour a partir des parametres systeme !',
          updated: 'Tarification mise a jour avec succes !',
          validated: '✅ Devis valide ! Email envoye au client avec le PDF.',
          rejected: 'Devis refuse avec succes.'
        },
        errors: {
          rateFetch: 'Echec de la recuperation des tarifs systeme',
          updateFailed: 'Echec de la mise a jour de la tarification',
          validateFailed: 'Echec de la validation du devis',
          rejectFailed: 'Echec du refus du devis'
        },
        statusLabels: {
          pending: 'En attente',
          validated: 'Valide',
          rejected: 'Refuse'
        },
        yes: 'Oui',
        no: 'Non',
        notSpecified: 'Non specifie'
      }
    }
  },
  en: {
    meta: {
      label: 'English',
      dir: 'ltr',
      locale: 'en-US',
      flag: '🇺🇸',
      flagImage: '/flags/us.svg'
    },
    header: {
      nav: {
        shipTrackQuote: 'Ship, track, quote',
        getQuote: 'Get a quote',
        services: 'Services',
        consulting: 'Transport consulting & services',
        road: 'Road transport (business)',
        careers: 'Careers',
        company: 'Company',
        about: 'About',
        contact: 'Contact',
        cta: 'Request a quote →'
      },
      searchLabel: 'Search',
      languageLabel: 'Language'
    },
    logo: {
      ariaLabel: 'Transport Logistics',
      alt: 'Transport Logistics'
    },
    home: {
      hero: {
        tagline: 'premium logistics',
        heading: 'Your freight, first',
        subheading: 'We are a leading LTL carrier with a high-performance network, technology, and service. Our platform simplifies shipping and delivers instant quotes for safe, fast deliveries.',
        ctaPrimary: 'Get a free quote',
        ctaSecondary: 'Contact our team',
        metrics: [
          { value: '24/7', label: 'Operations across the continent' },
          { value: '98%', label: 'On-time deliveries' },
          { value: '50+', label: 'Active partner clients' }
        ]
      },
      services: {
        heading: 'Our transport services',
        intro: 'Multimodal solutions designed to secure, accelerate, and track every shipment. Choose the offer that fits your flow and let our teams orchestrate each journey.',
        items: [
          {
            title: 'Transport consulting & services',
            tag: 'expertise',
            description: 'Dedicated teams to orchestrate operations, optimize costs, and ensure customs compliance.',
            highlights: [
              'Certified freight forwarders',
              'Ground services for airlines',
              'Shipchandlers'
            ],
            linkLabel: 'Discover our support'
          },
          {
            title: 'Road transport (business)',
            tag: 'operations',
            description: 'Reliable, flexible road solutions to support daily and international flows.',
            highlights: [
              'Road freight services',
              'Urban transport',
              'International TIR transport',
              'School transport'
            ],
            linkLabel: 'Explore road services'
          }
        ]
      },
      features: {
        tag: 'ADVANTAGES',
        title: 'Why choose our transport services',
        description: 'An integrated offer combining customs expertise, airport presence, road coverage, and people mobility. Each visual highlights a key pillar coordinated by our teams.',
        controls: {
          prev: 'Previous slide',
          next: 'Next slide',
          indicatorPrefix: 'Go to'
        },
        cards: [
          {
            title: 'Certified customs leadership',
            description: 'Licensed forwarders, document compliance, and proactive tracking to smooth every border crossing.',
            tag: 'Compliance'
          },
          {
            title: 'Airport operations',
            description: 'Handling coordination, ground services, and dock management to support your air rotations.',
            tag: 'Air'
          },
          {
            title: 'Agile road network',
            description: 'Freight, urban, and international TIR solutions for reliable, flexible road flows.',
            tag: 'Road'
          },
          {
            title: 'Community mobility',
            description: 'School transport and local shuttles delivered by verified drivers and modern fleets.',
            tag: 'Mobility'
          }
        ]
      },
      metrics: {
        title: 'Key metrics',
        intro: 'A network built around operational performance, cargo security, and a responsible approach. These indicators summarize the guarantees we offer across every lane.',
        stats: [
          {
            value: '98%',
            label: 'On-time delivery',
            description: 'Annual punctuality rate backed by verified drivers and partners.'
          },
          {
            value: '0 major incidents',
            label: 'Cargo safety',
            description: 'Proactive protocols and digital control chains to protect sensitive freight.'
          },
          {
            value: '30 min',
            label: 'Average response time',
            description: '24/7 operations support with a dedicated coordination center per corridor.'
          },
          {
            value: '-18%',
            label: 'Carbon footprint',
            description: 'Fleet modernization and carbon offsets for more sustainable corridors.'
          }
        ],
        milestones: [
          {
            year: '1998',
            title: 'Launch of our main hub',
            description: 'Opened the first multi-modal terminal linking north and south with centralized tracking.'
          },
          {
            year: '2008',
            title: 'Customs accreditation',
            description: 'Achieved OEA and C-TPAT certifications to simplify cross-border formalities.'
          },
          {
            year: '2016',
            title: 'Unified visibility platform',
            description: 'Launched a customer portal with real-time tracking, quotes, and performance analytics.'
          },
          {
            year: '2023',
            title: 'Clean energy commitment',
            description: 'Converted 40% of the fleet to hybrid and electric solutions on short corridors.'
          }
        ]
      },
      cta: {
        title: 'Ready to optimize your shipments?',
        description: 'Join thousands of businesses that trust our transport services for reliable, efficient, and cost-effective solutions. Start today to see what logistics expertise can unlock.',
        primary: 'Get a free quote',
        secondary: 'Contact our team'
      }
    },
    footer: {
      intro: 'Your trusted partner for transport and logistics. We deliver efficient shipping solutions to businesses of all sizes across the country and internationally.',
      quickLinks: {
        title: 'Quick links',
        items: [
          { label: 'Home', to: '/' },
          { label: 'Services', to: '/services' },
          { label: 'Track shipment', to: '/tracking' },
          { label: 'Get a quote', to: '/quote' },
          { label: 'Careers', to: '/careers' },
          { label: 'About', to: '/about' }
        ]
      },
      services: {
        title: 'Our services',
        items: [
          { label: 'LTL freight', to: '/services/ltl' },
          { label: 'Full truckload', to: '/services/ftl' },
          { label: 'International transport', to: '/services/international' },
          { label: 'Expedited delivery', to: '/services/expedited' },
          { label: 'Warehousing', to: '/services/warehousing' },
          { label: 'Logistics management', to: '/services/logistics' }
        ]
      },
      contact: {
        title: 'Contact us',
        address: '4 OP GH1 CHAMPS DU PRINTEMPS ETG 4 APPT 10 IMM D, Casablanca Province, Casablanca, Morocco'
      },
      bottom: {
        rights: 'All rights reserved.',
        terms: 'Terms & conditions',
        privacy: 'Privacy policy'
      }
    },
    pages: {
      services: {
        tag: '360 solutions',
        title: 'Services aligned to your supply chain',
        intro: 'From single pallets to enterprise programs, our transport experts deliver solutions that keep freight moving. Discover our core offers and see how our teams combine technology, visibility, and reliable execution to support your business goals.',
        stats: [
          { value: '24/7', label: 'Operations across North America' },
          { value: '98%', label: 'On-time deliveries last year' },
          { value: '5,000+', label: 'Satisfied shippers supported each year' },
          { value: '350+', label: 'Strategic logistics partners worldwide' }
        ]
      },
      tracking: {
        title: 'Track your shipment',
        intro: 'Enter your tracking number to view the latest updates from our operations teams. We provide real-time notifications at every transit stage.',
        placeholder: 'e.g. TRK-4589-2034',
        button: 'Track',
        help: 'Need help? Email tracking@transportcompany.com or call (800) 123-4567.',
        updatesTitle: 'Latest updates',
        updates: [
          {
            title: 'Shipment in transit',
            description: 'Departed the Dallas (TX) regional hub. ETA: 2 days.'
          },
          {
            title: 'Customs cleared',
            description: 'International documents verified. Final delivery prepared.'
          },
          {
            title: 'Proof of delivery',
            description: 'Electronic signature will be available upon delivery.'
          }
        ],
        alert: 'Tracking shipment number: {trackingNumber}'
      },
      quote: {
        title: 'Request a transport quote',
        intro: 'Fill out the form below to get an instant estimate for your shipment. Our team will validate your quote and email the official document within 24 hours.',
        success: '✅ Your quote request was sent successfully! We will contact you shortly by email with the official quote.',
        errorFallback: 'An error occurred. Please try again.',
        sections: {
          contact: 'Contact information',
          transport: 'Transport details',
          route: 'Route'
        },
        fields: {
          name: 'Full name',
          company: 'Company',
          phone: 'Phone',
          email: 'Email',
          transportType: 'Transport type',
          originContinent: 'Origin continent',
          originCountry: 'Origin country',
          originCity: 'Origin city',
          destinationContinent: 'Destination continent',
          destinationCountry: 'Destination country',
          destinationCity: 'Destination city',
          quantity: 'Quantity',
          unit: 'Unit',
          desiredDate: 'Desired date',
          roundTrip: 'Round trip',
          comments: 'Comments or special requirements'
        },
        placeholders: {
          name: 'John Doe',
          company: 'Company LLC',
          phone: '+212 6XX-XXXXXX',
          email: 'john.doe@example.com',
          quantity: '10',
          comments: 'Any extra info that might help us...'
        },
        selects: {
          selectType: '-- Select a type --',
          selectContinent: '-- Select a continent --',
          selectCountry: '-- Select a country --',
          selectCity: '-- Select a city --'
        },
        units: {
          tonne: 'Tonne',
          m3: 'm3 (cubic meter)'
        },
        estimate: {
          label: 'Estimated price (incl. tax)',
          note: '* This is an estimate. Final pricing will be confirmed after validation by our team.'
        },
        calculating: '🔄 Calculating estimated price...',
        submit: {
          idle: '📨 Get my quote',
          loading: '⏳ Sending...'
        },
        disclaimer: 'By submitting this form, you agree to be contacted by our sales team. Your data is protected and never shared with third parties.',
        transportFallbacks: [
          { id: 'road', label: 'Road transport' },
          { id: 'sea', label: 'Sea transport' },
          { id: 'air', label: 'Air transport' }
        ]
      },
      careers: {
        tag: 'Pride Trans',
        title: 'Meet our founder and CEO',
        intro: 'Hicham El Hammadi founded Pride Trans to deliver rare on-the-ground expertise and customer proximity in the Moroccan transport market. A passionate entrepreneur, he leads every project with commitment and ensures partners and drivers have the best conditions to succeed.',
        quote: '“Every mission we accept is a personal commitment. We want clients to feel they have a trusted partner by their side, whatever the logistics challenge.”',
        signatureRole: 'Founder & CEO, Pride Trans',
        portraitAlt: 'Hicham El Hammadi, founder of Pride Trans',
        visionTitle: 'His vision',
        visionParagraphs: [
          'After more than a decade in transport and logistics, Hicham El Hammadi built Pride Trans around a simple principle: combine operational rigor with human proximity. He studies every client request, selects the right teams, and deploys real-time supervision to ensure driver safety and customer satisfaction.',
          'His leadership fosters a culture of excellence and shared accountability. Pride Trans invests in continuous training, flow digitization, and fleet maintenance to guarantee reliable operations across Morocco and internationally.'
        ]
      },
      about: {
        title: 'About Transport Company',
        intro: 'We are a private carrier delivering reliable service across North America. Our teams orchestrate every shipment with precision, combining a modern fleet, strategic terminals, and innovative technology to ensure secure, on-time freight.',
        missionTitle: 'Our mission',
        missionText: 'Connect businesses to the capacity they need, exactly when they need it. We work closely with clients to understand supply chains, design resilient strategies, and execute with impeccable service.',
        valuesTitle: 'Our values',
        valuesText: 'Safety, integrity, and accountability guide every decision. We invest in teams, technology, and sustainable practices to deliver remarkable results for shippers, drivers, and communities.',
        milestones: [
          {
            year: '1998',
            text: 'Transport Company launches a single terminal with a mission to modernize regional freight.'
          },
          {
            year: '2005',
            text: 'Expanded national LTL coverage and created our first customs brokerage team.'
          },
          {
            year: '2014',
            text: 'Deployed a cloud visibility platform with proactive notifications for shippers and recipients.'
          },
          {
            year: '2022',
            text: 'Opened our innovation lab focused on sustainability, robotics, and data-driven logistics.'
          }
        ]
      },
      contact: {
        tag: 'contact',
        title: 'Let\'s talk about your transport operations',
        intro: 'Our support cell is available 7 days a week to track shipments, coordinate requests, and prepare quotes. Choose the channel that fits you or send your message directly.',
        directTitle: 'Direct contacts',
        directLabels: {
          customerService: 'Customer service',
          dispatch: 'Dispatch operations',
          email: 'Email support'
        },
        locationsTitle: 'Our locations',
        locationsIntro: 'Our teams are based in Morocco with partner relays in key regional hubs. We can schedule on-site or video meetings to audit your needs and launch an immediate action plan.',
        locations: [
          {
            title: 'Casablanca',
            text: 'Headquarters and control tower. Sales support, transport monitoring, and centralized customs coordination.'
          },
          {
            title: 'Tanger Med',
            text: 'Port team dedicated to import/export formalities and monitoring road and maritime transport.'
          },
          {
            title: 'Marrakech',
            text: 'Operational branch for regional distribution missions and on-the-ground driver support.'
          }
        ],
        formTitle: 'Send a message',
        formIntro: 'Share your transport details and we will get back within 24 business hours with an action plan.',
        form: {
          name: 'Full name',
          company: 'Company',
          email: 'Email address',
          phone: 'Phone',
          message: 'How can we help you?'
        },
        placeholders: {
          name: 'Your name',
          company: 'Your company name',
          email: 'you@company.com',
          phone: 'Your number',
          message: 'Describe your logistics need'
        },
        submit: 'Send request',
        disclaimer: 'By sending this form, you agree that our team may contact you by phone or email.'
      },
      consulting: {
        tag: 'advisory & control',
        title: 'Dedicated transport experts for your strategy',
        intro: 'Our advisory team coordinates your transport, customs, and supply chain files to streamline operations, reduce risk, and align stakeholders around shared KPIs. We act as an extension of your logistics leadership.',
        highlightTitle: 'What we deliver',
        highlightText: 'We establish clear transport governance with standardized processes, digital tools to track flows, and direct relationships with authorities and logistics partners.',
        focusList: [
          'Customs and tax compliance audits',
          'Import/export documentation management',
          'Supply chain process re-engineering',
          'Logistics performance KPI management'
        ],
        programsTitle: 'Personalized support programs',
        programsIntro: 'Each mission starts with a full diagnostic of your flows and tools. We then build a four-week roadmap with workshops across finance, operations, and IT teams to prioritize quick wins and long-term moves.',
        pillars: [
          {
            title: 'Control tower',
            text: 'We design a control center tailored to your organization with clear escalation points and real-time shared reporting.'
          },
          {
            title: 'On-site support',
            text: 'Our consultants work on-site to train teams on transport best practices, digitize procedures, and coordinate partners.'
          },
          {
            title: 'Regulatory watch',
            text: 'We maintain continuous regulatory watch and propose adaptation scenarios to secure international operations.'
          }
        ],
        kpiTitle: 'KPIs tracked',
        kpiIntro: 'We monitor your operations via a shared cockpit with leadership teams and automated reporting. KPIs are adjusted to your service, cost, and sustainability targets.',
        kpis: [
          { value: '30%', label: 'Average reduction in indirect costs' },
          { value: '12h', label: 'Standard lead time to deploy an action plan' },
          { value: '65+', label: 'Experts available across subsidiaries and hubs' },
          { value: '100%', label: 'Digitally documented audit-ready files' }
        ]
      },
      road: {
        tag: 'road transport',
        title: 'Field-proven solutions for your B2B flows',
        intro: 'From local pickup to international lanes, our road teams deliver an agile, reliable network. We combine planning, digital tracking, and tailored capacity to support sensitive operations.',
        metricsTitle: 'Our advantage on the road',
        metrics: [
          'Domestic and cross-border 24/7 operations',
          'Hybrid fleet and temperature-controlled equipment',
          'Proactive dispatch and real-time ETA tracking',
          'Certified drivers and safety training'
        ],
        linesTitle: 'Flexible service lines',
        linesIntro: 'We configure resources around your volumes, delivery windows, and sector requirements. Each contract is led by an account manager coordinating drivers, chartering, and customer service.',
        serviceLines: [
          {
            title: 'Parcel and LTL',
            text: 'Smart pallet consolidation, precise deliveries, automated notifications, and SLAs tailored to B2B flows.'
          },
          {
            title: 'FTL and special projects',
            text: 'Spot capacity and long-term contracts, escorts when needed, and permits for oversized loads.'
          },
          {
            title: 'Urban distribution',
            text: 'Optimized routes with low-emission vehicles to serve city centers and low-emission zones.'
          },
          {
            title: 'Dedicated services',
            text: 'Dedicated drivers, dedicated chartering, and integration with your WMS and TMS to manage orders live.'
          }
        ],
        logisticsTitle: 'Logistics setup',
        logisticsIntro: 'Our teams plan routes in coordination with your supply chain and rely on in-house tools to adjust paths in real time. We cover both regular flows and critical operations.',
        logistics: [
          {
            title: 'Technical capabilities',
            items: [
              'Mega volume and refrigerated trailers',
              'ADR vehicles for hazardous goods',
              'Special racks for sensitive loads',
              'On-board telematics for eco-driving'
            ]
          },
          {
            title: 'Operational coordination',
            items: [
              '24/7 control tower with bilingual dispatch',
              'Client portal with ETA and POD information',
              'EDI and API integration with your tools',
              'Joint planning with shippers'
            ]
          },
          {
            title: 'Sustainability commitments',
            items: [
              'Empty-mile optimization',
              'On-demand carbon offsets',
              'Driver ambassador safety program',
              'Preventive maintenance and low-resistance tires'
            ]
          }
        ]
      },
      adminLogin: {
        logo: 'Transport Admin',
        subLogo: 'Administration panel',
        title: 'Sign in',
        username: 'Username',
        password: 'Password',
        usernamePlaceholder: 'Enter your username',
        passwordPlaceholder: 'Enter your password',
        submitIdle: 'Sign in',
        submitLoading: 'Signing in...',
        errorEmpty: 'Please fill in all fields',
        errorInvalid: 'Invalid credentials. Please try again.',
        demo: 'Demo',
        demoText: 'User: admin / Password: admin123'
      },
      adminDashboard: {
        logo: 'Transport Admin',
        userLabel: 'Administrator',
        settings: 'Settings',
        logout: 'Log out',
        title: 'Dashboard',
        subtitle: 'Manage transport quote requests',
        stats: {
          total: 'Total requests',
          pending: 'Pending',
          processed: 'Processed',
          rejected: 'Rejected'
        },
        filterLabel: 'Filter by status:',
        filterOptions: {
          all: 'All',
          pending: 'Pending',
          processed: 'Processed',
          rejected: 'Rejected'
        },
        empty: {
          loading: 'Loading...',
          title: 'No quote requests',
          subtitle: 'Quote requests will appear here.'
        },
        table: {
          date: 'Date',
          contact: 'Contact',
          email: 'Email',
          route: 'Route',
          status: 'Status',
          actions: 'Actions',
          viewDetails: 'View details'
        },
        alerts: {
          updateStatus: 'Failed to update status',
          deleteConfirm: 'Are you sure you want to delete this request?',
          deleteError: 'Failed to delete request'
        },
        statusLabels: {
          pending: 'Pending',
          processed: 'Processed',
          rejected: 'Rejected'
        }
      },
      adminSettings: {
        back: 'Back to dashboard',
        title: 'System settings',
        save: 'Save changes',
        saving: 'Saving...',
        saved: 'Settings saved successfully!',
        saveFailed: 'Failed to save settings.',
        loadFailed: 'Failed to load settings. Using defaults.',
        transportTitle: 'Transport types pricing',
        newTypePlaceholder: 'New transport type name (e.g. Rail)',
        addType: '+ Add',
        deleteType: 'Delete type',
        rateKm: 'Rate per km (MAD)',
        rateTonne: 'Rate per tonne (MAD)',
        fixedFees: 'Fixed fees (MAD)',
        europeTitle: 'Europe settings',
        europeEnable: 'Enable special pricing for Europe',
        multiplier: 'Price multiplier (1.0 = normal)',
        surcharge: 'Additional fixed surcharge (MAD)',
        africaTitle: 'Africa settings',
        africaEnable: 'Enable special pricing for Africa',
        activeCountries: 'Active African countries (multi-select)',
        selectHint: 'Hold Ctrl (Windows) or Cmd (Mac) to select multiple countries.',
        loading: 'Loading...'
      }
    },
    modal: {
      quoteDetail: {
        title: 'Quote #{id}',
        clientInfo: 'Client information',
        transportInfo: 'Transport details',
        pricingTitle: 'Quote settings (editable)',
        resetRates: 'Reset with system rates',
        fields: {
          name: 'Name',
          company: 'Company',
          email: 'Email',
          phone: 'Phone',
          status: 'Status',
          requestDate: 'Request date',
          transportType: 'Transport type',
          origin: 'Origin',
          destination: 'Destination',
          distance: 'Distance',
          quantity: 'Quantity',
          desiredDate: 'Desired date',
          roundTrip: 'Round trip',
          comments: 'Comments',
          distanceKm: 'Distance (km)',
          quantityUnit: 'Quantity ({unit})',
          rateKm: 'Rate per km (MAD)',
          rateTonne: 'Rate per tonne (MAD)',
          fixedFees: 'Fixed fees (MAD)',
          discount: 'Discount (%)',
          vat: 'VAT (%)'
        },
        selectType: 'Select...',
        price: {
          label: 'Final price (incl. tax)',
          distance: 'Distance ({distance} km x {rate})',
          quantity: 'Quantity ({quantity} x {rate})',
          fixed: 'Fixed fees',
          subtotal: 'Subtotal (excl. tax)',
          discount: 'Discount ({discount}%)',
          afterDiscount: 'Subtotal after discount',
          vat: 'VAT ({vat}%)',
          total: 'TOTAL'
        },
        buttons: {
          save: 'Save changes',
          reject: 'Reject quote',
          validate: 'Approve quote (PDF + Email)'
        },
        badges: {
          validated: 'Quote approved on {date}',
          rejected: 'Quote rejected on {date}'
        },
        confirm: {
          validate: 'Approve this quote and email the client?',
          reject: 'Are you sure you want to reject this quote?'
        },
        success: {
          ratesUpdated: 'Rates updated from system settings!',
          updated: 'Pricing updated successfully!',
          validated: '✅ Quote approved! Email sent to client with PDF.',
          rejected: 'Quote rejected successfully.'
        },
        errors: {
          rateFetch: 'Failed to fetch system rates',
          updateFailed: 'Failed to update pricing',
          validateFailed: 'Failed to approve quote',
          rejectFailed: 'Failed to reject quote'
        },
        statusLabels: {
          pending: 'Pending',
          validated: 'Approved',
          rejected: 'Rejected'
        },
        yes: 'Yes',
        no: 'No',
        notSpecified: 'Not specified'
      }
    }
  },
  ar: {
    meta: {
      label: 'العربية',
      dir: 'rtl',
      locale: 'ar-MA',
      flag: '🇲🇦',
      flagImage: '/flags/ma.svg'
    },
    header: {
      nav: {
        shipTrackQuote: 'اشحن وتتبع واطلب عرض سعر',
        getQuote: 'اطلب عرض سعر',
        services: 'الخدمات',
        consulting: 'استشارات وخدمات النقل',
        road: 'النقل البري (للشركات)',
        careers: 'المسارات المهنية',
        company: 'الشركة',
        about: 'من نحن',
        contact: 'اتصل بنا',
        cta: 'اطلب عرض سعر →'
      },
      searchLabel: 'بحث',
      languageLabel: 'اللغة'
    },
    logo: {
      ariaLabel: 'لوجستيات النقل',
      alt: 'لوجستيات النقل'
    },
    home: {
      hero: {
        tagline: 'لوجستيات مميزة',
        heading: 'شحنتك اولاً',
        subheading: 'نحن رواد في شحنات LTL مع شبكة عالية الاداء وتقنية وخدمة من المستوى الاول. منصتنا تبسط الشحن وتقدم عروض اسعار فورية لتسليمات امنة وسريعة.',
        ctaPrimary: 'احصل على عرض سعر مجاني',
        ctaSecondary: 'تواصل مع فريقنا',
        metrics: [
          { value: '24/7', label: 'عمليات على مستوى القارة' },
          { value: '98%', label: 'تسليمات في الوقت المحدد' },
          { value: '50+', label: 'عملاء شركاء نشطون' }
        ]
      },
      services: {
        heading: 'خدمات النقل لدينا',
        intro: 'حلول متعددة الوسائط صممت لتامين وتسريع وتتبع كل شحنة. اختر العرض الانسب لتدفقاتك واترك لفرقنا تنسيق كل رحلة.',
        items: [
          {
            title: 'استشارات وخدمات النقل',
            tag: 'خبرة',
            description: 'فرق مخصصة لتنسيق العمليات وتحسين التكاليف وضمان الامتثال الجمركي.',
            highlights: [
              'وسطاء شحن معتمدون',
              'خدمات ارضية لشركات الطيران',
              'خدمات تموين السفن'
            ],
            linkLabel: 'اكتشف الدعم'
          },
          {
            title: 'النقل البري (للشركات)',
            tag: 'عمليات',
            description: 'حلول برية موثوقة ومرنة لدعم التدفقات اليومية والدولية.',
            highlights: [
              'خدمات شحن بري للبضائع',
              'نقل حضري',
              'نقل دولي TIR',
              'نقل مدرسي'
            ],
            linkLabel: 'استكشف خدماتنا البرية'
          }
        ]
      },
      features: {
        tag: 'المزايا',
        title: 'لماذا تختار خدمات النقل لدينا',
        description: 'عرض متكامل يجمع خبرة جمركية وحضورا مطاريا وتغطية برية وتنقل افراد. كل عنصر يبرز ركيزة رئيسية تنسقها فرقنا.',
        controls: {
          prev: 'الشريحة السابقة',
          next: 'الشريحة التالية',
          indicatorPrefix: 'اذهب الى'
        },
        cards: [
          {
            title: 'ادارة جمركية معتمدة',
            description: 'وسطاء مرخصون وامتثال وثائقي وتتبع استباقي لتسهيل كل عبور حدودي.',
            tag: 'امتثال'
          },
          {
            title: 'عمليات مطارية',
            description: 'تنسيق الخدمات الارضية والتعامل في الارصفة لدعم رحلاتك الجوية.',
            tag: 'جوي'
          },
          {
            title: 'شبكة برية مرنة',
            description: 'حلول للبضائع والحضر وTIR الدولي لتدفقات برية موثوقة ومرنة.',
            tag: 'بري'
          },
          {
            title: 'تنقل مجتمعي',
            description: 'نقل مدرسي وتنقل محلي يديره سائقون موثقون واساطيل حديثة.',
            tag: 'تنقل'
          }
        ]
      },
      metrics: {
        title: 'ارقامنا الرئيسية',
        intro: 'شبكة مبنية على الاداء التشغيلي وامن البضائع ونهج مسؤول. هذه المؤشرات تلخص الضمانات عبر كل المسارات.',
        stats: [
          {
            value: '98%',
            label: 'تسليمات في الموعد',
            description: 'معدل التزام سنوي مدعوم بسائقين وشركاء موثوقين.'
          },
          {
            value: '0 حادث كبير',
            label: 'سلامة الشحنة',
            description: 'بروتوكولات استباقية وسلاسل رقابة رقمية لحماية الشحنات الحساسة.'
          },
          {
            value: '30 دقيقة',
            label: 'متوسط زمن الاستجابة',
            description: 'دعم عمليات على مدار الساعة مع مركز تنسيق مخصص لكل ممر.'
          },
          {
            value: '-18%',
            label: 'البصمة الكربونية',
            description: 'تحديث الاسطول وتعويضات كربونية لممرات اكثر استدامة.'
          }
        ],
        milestones: [
          {
            year: '1998',
            title: 'اطلاق المركز الرئيسي',
            description: 'افتتاح اول محطة متعددة الوسائط تربط الشمال والجنوب مع تتبع مركزي.'
          },
          {
            year: '2008',
            title: 'اعتماد جمركي',
            description: 'الحصول على شهادات OEA و C-TPAT لتبسيط الاجراءات الحدودية.'
          },
          {
            year: '2016',
            title: 'منصة رؤية موحدة',
            description: 'اطلاق بوابة العملاء مع تتبع لحظي وعروض اسعار وتحليلات اداء.'
          },
          {
            year: '2023',
            title: 'التزام بالطاقة النظيفة',
            description: 'تحويل 40% من الاسطول الى حلول هجينة وكهربائية في الممرات القصيرة.'
          }
        ]
      },
      cta: {
        title: 'جاهز لتحسين شحناتك؟',
        description: 'انضم الى الاف الشركات التي تثق بخدماتنا لنقل موثوق وفعال وموفر. ابدأ اليوم لاكتشاف قيمة خبرتنا اللوجستية.',
        primary: 'احصل على عرض سعر مجاني',
        secondary: 'تواصل مع فريقنا'
      }
    },
    footer: {
      intro: 'شريكك الموثوق في النقل واللوجستيات. نقدم حلولا فعالة للشحن للشركات بمختلف الاحجام محليا ودوليا.',
      quickLinks: {
        title: 'روابط سريعة',
        items: [
          { label: 'الرئيسية', to: '/' },
          { label: 'الخدمات', to: '/services' },
          { label: 'تتبع الشحنة', to: '/tracking' },
          { label: 'اطلب عرض سعر', to: '/quote' },
          { label: 'المسارات المهنية', to: '/careers' },
          { label: 'من نحن', to: '/about' }
        ]
      },
      services: {
        title: 'خدماتنا',
        items: [
          { label: 'شحن LTL', to: '/services/ltl' },
          { label: 'حمولة كاملة', to: '/services/ftl' },
          { label: 'نقل دولي', to: '/services/international' },
          { label: 'تسليم سريع', to: '/services/expedited' },
          { label: 'تخزين', to: '/services/warehousing' },
          { label: 'ادارة لوجستية', to: '/services/logistics' }
        ]
      },
      contact: {
        title: 'تواصل معنا',
        address: '4 OP GH1 CHAMPS DU PRINTEMPS ETG 4 APPT 10 IMM D، عمالة الدار البيضاء، الدار البيضاء، المغرب'
      },
      bottom: {
        rights: 'جميع الحقوق محفوظة.',
        terms: 'الشروط والاحكام',
        privacy: 'سياسة الخصوصية'
      }
    },
    pages: {
      services: {
        tag: 'حلول 360',
        title: 'خدمات مصممة لسلسلة التوريد الخاصة بك',
        intro: 'من الطرود الفردية الى البرامج المؤسسية، يقدم خبراؤنا حلولا تحافظ على حركة الشحنات. اكتشف عروضنا الاساسية وشاهد كيف تجمع فرقنا بين التقنية والرؤية والتنفيذ الموثوق.',
        stats: [
          { value: '24/7', label: 'عمليات عبر اميركا الشمالية' },
          { value: '98%', label: 'تسليمات في الوقت المحدد العام الماضي' },
          { value: '5,000+', label: 'مرسلون راضون تتم خدمتهم سنويا' },
          { value: '350+', label: 'شركاء لوجستيون استراتيجيون حول العالم' }
        ]
      },
      tracking: {
        title: 'تتبع شحنتك',
        intro: 'ادخل رقم التتبع للاطلاع على اخر التحديثات من فرق العمليات. نوفر اشعارات فورية في كل مرحلة من مراحل النقل.',
        placeholder: 'مثال TRK-4589-2034',
        button: 'تتبع',
        help: 'هل تحتاج مساعدة؟ ارسل الى tracking@transportcompany.com او اتصل بـ (800) 123-4567.',
        updatesTitle: 'اخر التحديثات',
        updates: [
          {
            title: 'الشحنة في الطريق',
            description: 'غادرت مركز دالاس (TX). الوصول المتوقع: يومان.'
          },
          {
            title: 'تمت الموافقة الجمركية',
            description: 'تم التحقق من المستندات الدولية. تجهيز التسليم النهائي.'
          },
          {
            title: 'اثبات التسليم',
            description: 'ستكون التوقيعات الالكترونية متاحة عند التسليم.'
          }
        ],
        alert: 'تتبع الشحنة رقم: {trackingNumber}'
      },
      quote: {
        title: 'طلب عرض سعر للنقل',
        intro: 'املأ النموذج ادناه للحصول على تقدير فوري لتكلفة الشحن. سيقوم فريقنا بالتحقق من العرض وارسال الوثيقة الرسمية عبر البريد خلال 24 ساعة.',
        success: '✅ تم ارسال طلب عرض السعر بنجاح! سنتواصل معك قريبا عبر البريد الالكتروني.',
        errorFallback: 'حدث خطأ. يرجى المحاولة مرة اخرى.',
        sections: {
          contact: 'معلومات الاتصال',
          transport: 'تفاصيل النقل',
          route: 'المسار'
        },
        fields: {
          name: 'الاسم الكامل',
          company: 'الشركة',
          phone: 'الهاتف',
          email: 'البريد الالكتروني',
          transportType: 'نوع النقل',
          originContinent: 'قارة الانطلاق',
          originCountry: 'بلد الانطلاق',
          originCity: 'مدينة الانطلاق',
          destinationContinent: 'قارة الوصول',
          destinationCountry: 'بلد الوصول',
          destinationCity: 'مدينة الوصول',
          quantity: 'الكمية',
          unit: 'الوحدة',
          desiredDate: 'التاريخ المطلوب',
          roundTrip: 'ذهاب واياب',
          comments: 'ملاحظات او متطلبات خاصة'
        },
        placeholders: {
          name: 'احمد بن علي',
          company: 'شركة SARL',
          phone: '+212 6XX-XXXXXX',
          email: 'ahmed@example.com',
          quantity: '10',
          comments: 'اي معلومات اضافية قد تساعدنا...'
        },
        selects: {
          selectType: '-- اختر النوع --',
          selectContinent: '-- اختر القارة --',
          selectCountry: '-- اختر البلد --',
          selectCity: '-- اختر المدينة --'
        },
        units: {
          tonne: 'طن',
          m3: 'متر مكعب (m3)'
        },
        estimate: {
          label: 'السعر التقديري (شامل الضريبة)',
          note: '* هذا تقدير. سيتم تاكيد السعر النهائي بعد مراجعة فريقنا.'
        },
        calculating: '🔄 جار حساب السعر التقديري...',
        submit: {
          idle: '📨 احصل على عرض السعر',
          loading: '⏳ جار الارسال...'
        },
        disclaimer: 'بتقديم هذا النموذج، توافق على ان يتواصل معك فريق المبيعات. بياناتك محمية ولن يتم مشاركتها مع اطراف ثالثة.',
        transportFallbacks: [
          { id: 'road', label: 'النقل البري' },
          { id: 'sea', label: 'النقل البحري' },
          { id: 'air', label: 'النقل الجوي' }
        ]
      },
      careers: {
        tag: 'Pride Trans',
        title: 'تعرف على المؤسس والمدير التنفيذي',
        intro: 'اسس هشام الحمادي شركة Pride Trans لتقديم خبرة ميدانية وقرب من العميل في سوق النقل المغربي. يقود كل مشروع بشغف ويضمن افضل الظروف للشركاء والسائقين.',
        quote: '"كل مهمة نقبلها هي التزام شخصي. نريد ان يشعر عملاؤنا بان لديهم شريكا موثوقا بجانبهم مهما كان التحدي اللوجستي."',
        signatureRole: 'المؤسس والرئيس التنفيذي، Pride Trans',
        portraitAlt: 'هشام الحمادي، مؤسس Pride Trans',
        visionTitle: 'رؤيته',
        visionParagraphs: [
          'بعد اكثر من عشر سنوات في النقل واللوجستيات، بنى هشام الحمادي Pride Trans على مبدأ بسيط: الجمع بين الصرامة التشغيلية والقرب الانساني. يدرس كل طلب عميل ويختار الفرق المناسبة ويطبق اشرافا فوريا لضمان سلامة السائقين ورضا العملاء.',
          'قيادته تعزز ثقافة التميز والمسؤولية المشتركة. تستثمر Pride Trans في التدريب المستمر ورقمنة التدفقات وصيانة الاسطول لضمان عمليات موثوقة داخل المغرب وخارجه.'
        ]
      },
      about: {
        title: 'حول Transport Company',
        intro: 'نحن ناقل خاص يقدم خدمة موثوقة عبر امريكا الشمالية. تنسق فرقنا كل شحنة بدقة من خلال اسطول حديث ومحطات استراتيجية وتقنيات مبتكرة لضمان شحن امن وفي الوقت المحدد.',
        missionTitle: 'مهمتنا',
        missionText: 'ربط الشركات بالطاقة الاستيعابية التي تحتاجها في الوقت المناسب. نتعاون مع عملائنا لفهم سلاسل التوريد وتصميم استراتيجيات مرنة وتنفيذها بخدمة متميزة.',
        valuesTitle: 'قيمنا',
        valuesText: 'السلامة والنزاهة والمسؤولية توجه كل قرار. نستثمر في الفرق والتقنية والممارسات المستدامة لنقدم نتائج استثنائية للشاحنين والسائقين والمجتمعات.',
        milestones: [
          {
            year: '1998',
            text: 'اطلقت Transport Company محطة واحدة بهدف تحديث الشحن الاقليمي.'
          },
          {
            year: '2005',
            text: 'توسيع تغطية LTL وطنيا وتأسيس اول فريق تخليص جمركي.'
          },
          {
            year: '2014',
            text: 'اطلاق منصة رؤية سحابية مع اشعارات استباقية للشاحنين والمستلمين.'
          },
          {
            year: '2022',
            text: 'افتتاح مختبر الابتكار للتركيز على الاستدامة والروبوتات واللوجستيات المدعومة بالبيانات.'
          }
        ]
      },
      contact: {
        tag: 'اتصال',
        title: 'دعنا نتحدث عن عملياتك اللوجستية',
        intro: 'فريق الدعم متاح 7 ايام في الاسبوع لتتبع الشحنات وتنسيق الطلبات وتهيئة عروض الاسعار. اختر القناة المناسبة او ارسل رسالتك مباشرة.',
        directTitle: 'وسائل اتصال مباشرة',
        directLabels: {
          customerService: 'خدمة العملاء',
          dispatch: 'عمليات التشغيل',
          email: 'دعم البريد الالكتروني'
        },
        locationsTitle: 'مواقعنا',
        locationsIntro: 'فرقنا تتمركز في المغرب مع شركاء في ابرز المراكز الاقليمية. يمكننا ترتيب لقاءات حضورية او عبر الفيديو لتقييم احتياجاتك واطلاق خطة عمل فورية.',
        locations: [
          {
            title: 'الدار البيضاء',
            text: 'المقر الرئيسي ومركز التحكم. دعم المبيعات وتتبع النقل والتنسيق الجمركي المركزي.'
          },
          {
            title: 'طنجة المتوسط',
            text: 'فريق ميناء متخصص في اجراءات الاستيراد والتصدير ومتابعة النقل البري والبحري.'
          },
          {
            title: 'مراكش',
            text: 'فرع تشغيلي لمهام التوزيع الاقليمي ودعم السائقين ميدانيا.'
          }
        ],
        formTitle: 'ارسل رسالة',
        formIntro: 'شارك تفاصيل النقل وسنعود اليك خلال 24 ساعة عمل بخطة اجرائية.',
        form: {
          name: 'الاسم الكامل',
          company: 'الشركة',
          email: 'البريد الالكتروني',
          phone: 'الهاتف',
          message: 'كيف يمكننا مساعدتك؟'
        },
        placeholders: {
          name: 'اسمك',
          company: 'اسم شركتك',
          email: 'you@company.com',
          phone: 'رقمك',
          message: 'اشرح احتياجك اللوجستي'
        },
        submit: 'ارسال الطلب',
        disclaimer: 'بارسال هذا النموذج، توافق على ان يتواصل معك فريقنا عبر الهاتف او البريد الالكتروني.'
      },
      consulting: {
        tag: 'الاستشارات والقيادة',
        title: 'خبراء نقل مخصصون لاستراتيجيتك',
        intro: 'فريقنا الاستشاري ينسق ملفات النقل والجمارك وسلاسل التوريد لتبسيط العمليات وتقليل المخاطر وتوحيد المعنيين حول مؤشرات مشتركة.',
        highlightTitle: 'ما الذي نقدمه',
        highlightText: 'نضع حوكمة نقل واضحة مع عمليات معيارية وادوات رقمية لتتبع التدفقات وعلاقات مباشرة مع الجهات والشركاء.',
        focusList: [
          'تدقيقات الامتثال الجمركي والضريبي',
          'ادارة وثائق الاستيراد والتصدير',
          'اعادة هندسة عمليات سلسلة التوريد',
          'ادارة مؤشرات اداء اللوجستيات'
        ],
        programsTitle: 'برامج دعم مخصصة',
        programsIntro: 'كل مهمة تبدأ بتشخيص كامل للتدفقات والادوات. ثم نبني خارطة طريق اربع اسابيع مع ورش عمل للمالية والعمليات وفرق التقنية لتحديد الاولويات.',
        pillars: [
          {
            title: 'مركز التحكم',
            text: 'نصمم مركز تحكم ملائما لمؤسستك مع نقاط تصعيد واضحة وتقارير مشتركة لحظيا.'
          },
          {
            title: 'دعم ميداني',
            text: 'يعمل مستشارونا في الموقع لتدريب الفرق على افضل ممارسات النقل ورقمنة الاجراءات وتنسيق الشركاء.'
          },
          {
            title: 'مراقبة تنظيمية',
            text: 'نضمن متابعة تنظيمية مستمرة ونقترح سيناريوهات للتكيف لحماية العمليات الدولية.'
          }
        ],
        kpiTitle: 'المؤشرات المتابعة',
        kpiIntro: 'نراقب اداء العمليات عبر لوحة مشتركة مع الادارة وتقارير قابلة للاتمتة. يتم ضبط المؤشرات حسب اهداف الخدمة والتكلفة والاستدامة.',
        kpis: [
          { value: '30%', label: 'متوسط خفض للتكاليف غير المباشرة' },
          { value: '12س', label: 'زمن قياسي لوضع خطة عمل' },
          { value: '65+', label: 'خبراء متاحون عبر الفروع والمراكز' },
          { value: '100%', label: 'ملفات موثقة رقميا قابلة للتدقيق' }
        ]
      },
      road: {
        tag: 'النقل البري',
        title: 'حلول ميدانية لتدفقات B2B',
        intro: 'من التجميع المحلي الى المسارات الدولية، توفر فرقنا شبكة مرنة وموثوقة. نجمع بين التخطيط والتتبع الرقمي والسعات المخصصة لدعم العمليات الحساسة.',
        metricsTitle: 'تميزنا على الطريق',
        metrics: [
          'عمليات محلية وعابرة للحدود 24/7',
          'اسطول هجين ومعدات بدرجات حرارة متحكم بها',
          'توجيه استباقي وتتبع ETA لحظي',
          'سائقون معتمدون وتدريب سلامة'
        ],
        linesTitle: 'خطوط خدمة مرنة',
        linesIntro: 'نضبط الموارد وفق احجامك ونوافذ التسليم ومتطلبات القطاع. كل عقد يديره مدير حساب ينسق السائقين والتعهد وخدمة العملاء.',
        serviceLines: [
          {
            title: 'شحنات مجمعة وLTL',
            text: 'تجميع ذكي للطبالي، تسليمات دقيقة، اشعارات تلقائية، واتفاقيات مستوى خدمة مناسبة لـ B2B.'
          },
          {
            title: 'FTL ومشاريع خاصة',
            text: 'سعات فورية وعقود طويلة، مرافقة عند الحاجة، وتصاريح للاحمال الخارجة عن المقاسات.'
          },
          {
            title: 'توزيع حضري',
            text: 'مسارات محسنة بمركبات منخفضة الانبعاثات لخدمة مراكز المدن والمناطق منخفضة الانبعاث.'
          },
          {
            title: 'خدمات مخصصة',
            text: 'سائقون مخصصون وتعهد مخصص وتكامل مع WMS وTMS لادارة الطلبات مباشرة.'
          }
        ],
        logisticsTitle: 'المنظومة اللوجستية',
        logisticsIntro: 'تخطط فرقنا المسارات بالتنسيق مع سلسلة التوريد وتعتمد ادوات داخلية لتعديل الطرق لحظيا. نغطي التدفقات المنتظمة والعمليات الحرجة.',
        logistics: [
          {
            title: 'قدرات تقنية',
            items: [
              'مقطورات حجم كبير ومبردة',
              'مركبات ADR للبضائع الخطرة',
              'حوامل خاصة للشحنات الحساسة',
              'قياس عن بعد لقيادة موفرة'
            ]
          },
          {
            title: 'تنسيق تشغيلي',
            items: [
              'مركز تحكم 24/7 مع توجيه ثنائي اللغة',
              'بوابة عملاء مع معلومات ETA و POD',
              'تكامل EDI و API مع ادواتك',
              'تخطيط مشترك مع الشاحنين'
            ]
          },
          {
            title: 'التزامات الاستدامة',
            items: [
              'تحسين الكيلومترات الفارغة',
              'تعويض كربوني عند الطلب',
              'برنامج سائق سفير للسلامة',
              'صيانة وقائية واطارات منخفضة المقاومة'
            ]
          }
        ]
      },
      adminLogin: {
        logo: 'Transport Admin',
        subLogo: 'لوحة الادارة',
        title: 'تسجيل الدخول',
        username: 'اسم المستخدم',
        password: 'كلمة المرور',
        usernamePlaceholder: 'ادخل اسم المستخدم',
        passwordPlaceholder: 'ادخل كلمة المرور',
        submitIdle: 'تسجيل الدخول',
        submitLoading: 'جار التحقق...',
        errorEmpty: 'يرجى ملء جميع الحقول',
        errorInvalid: 'بيانات الدخول غير صحيحة. حاول مرة اخرى.',
        demo: 'تجربة',
        demoText: 'المستخدم: admin / كلمة المرور: admin123'
      },
      adminDashboard: {
        logo: 'Transport Admin',
        userLabel: 'مسؤول',
        settings: 'الاعدادات',
        logout: 'تسجيل الخروج',
        title: 'لوحة التحكم',
        subtitle: 'ادارة طلبات عروض اسعار النقل',
        stats: {
          total: 'اجمالي الطلبات',
          pending: 'قيد الانتظار',
          processed: 'معالج',
          rejected: 'مرفوض'
        },
        filterLabel: 'تصفية حسب الحالة:',
        filterOptions: {
          all: 'الكل',
          pending: 'قيد الانتظار',
          processed: 'معالج',
          rejected: 'مرفوض'
        },
        empty: {
          loading: 'جار التحميل...',
          title: 'لا توجد طلبات عروض اسعار',
          subtitle: 'ستظهر طلبات عروض الاسعار هنا.'
        },
        table: {
          date: 'التاريخ',
          contact: 'جهة الاتصال',
          email: 'البريد الالكتروني',
          route: 'المسار',
          status: 'الحالة',
          actions: 'الاجراءات',
          viewDetails: 'عرض التفاصيل'
        },
        alerts: {
          updateStatus: 'تعذر تحديث الحالة',
          deleteConfirm: 'هل انت متاكد من حذف هذا الطلب؟',
          deleteError: 'تعذر حذف الطلب'
        },
        statusLabels: {
          pending: 'قيد الانتظار',
          processed: 'معالج',
          rejected: 'مرفوض'
        }
      },
      adminSettings: {
        back: 'العودة الى لوحة التحكم',
        title: 'اعدادات النظام',
        save: 'حفظ التغييرات',
        saving: 'جار الحفظ...',
        saved: 'تم حفظ الاعدادات بنجاح!',
        saveFailed: 'فشل حفظ الاعدادات.',
        loadFailed: 'تعذر تحميل الاعدادات. سيتم استخدام القيم الافتراضية.',
        transportTitle: 'تسعير انواع النقل',
        newTypePlaceholder: 'نوع نقل جديد (مثال: قطار)',
        addType: '+ اضافة',
        deleteType: 'حذف النوع',
        rateKm: 'سعر لكل كم (MAD)',
        rateTonne: 'سعر لكل طن (MAD)',
        fixedFees: 'رسوم ثابتة (MAD)',
        europeTitle: 'اعدادات اوروبا',
        europeEnable: 'تفعيل تسعير خاص لاوروبا',
        multiplier: 'معامل السعر (1.0 = عادي)',
        surcharge: 'رسوم ثابتة اضافية (MAD)',
        africaTitle: 'اعدادات افريقيا',
        africaEnable: 'تفعيل تسعير خاص لافريقيا',
        activeCountries: 'الدول الافريقية النشطة (تحديد متعدد)',
        selectHint: 'اضغط Ctrl (ويندوز) او Cmd (ماك) لتحديد اكثر من دولة.',
        loading: 'جار التحميل...'
      }
    },
    modal: {
      quoteDetail: {
        title: 'عرض سعر رقم {id}',
        clientInfo: 'معلومات العميل',
        transportInfo: 'تفاصيل النقل',
        pricingTitle: 'اعدادات العرض (قابلة للتعديل)',
        resetRates: 'اعادة ضبط بالتعريفات النظامية',
        fields: {
          name: 'الاسم',
          company: 'الشركة',
          email: 'البريد الالكتروني',
          phone: 'الهاتف',
          status: 'الحالة',
          requestDate: 'تاريخ الطلب',
          transportType: 'نوع النقل',
          origin: 'الانطلاق',
          destination: 'الوصول',
          distance: 'المسافة',
          quantity: 'الكمية',
          desiredDate: 'التاريخ المطلوب',
          roundTrip: 'ذهاب واياب',
          comments: 'ملاحظات',
          distanceKm: 'المسافة (كم)',
          quantityUnit: 'الكمية ({unit})',
          rateKm: 'سعر لكل كم (MAD)',
          rateTonne: 'سعر لكل طن (MAD)',
          fixedFees: 'رسوم ثابتة (MAD)',
          discount: 'خصم (%)',
          vat: 'الضريبة (%)'
        },
        selectType: 'اختر...',
        price: {
          label: 'السعر النهائي (شامل الضريبة)',
          distance: 'المسافة ({distance} كم x {rate})',
          quantity: 'الكمية ({quantity} x {rate})',
          fixed: 'رسوم ثابتة',
          subtotal: 'المجموع الفرعي (بدون ضريبة)',
          discount: 'الخصم ({discount}%)',
          afterDiscount: 'المجموع بعد الخصم',
          vat: 'الضريبة ({vat}%)',
          total: 'الاجمالي'
        },
        buttons: {
          save: 'حفظ التغييرات',
          reject: 'رفض عرض السعر',
          validate: 'اعتماد العرض (PDF + بريد)'
        },
        badges: {
          validated: 'تم اعتماد العرض بتاريخ {date}',
          rejected: 'تم رفض العرض بتاريخ {date}'
        },
        confirm: {
          validate: 'اعتماد هذا العرض وارسال بريد للعميل؟',
          reject: 'هل انت متاكد من رفض هذا العرض؟'
        },
        success: {
          ratesUpdated: 'تم تحديث التعريفات من اعدادات النظام!',
          updated: 'تم تحديث التسعير بنجاح!',
          validated: '✅ تم اعتماد العرض! تم ارسال البريد مع ملف PDF.',
          rejected: 'تم رفض العرض بنجاح.'
        },
        errors: {
          rateFetch: 'تعذر جلب التعريفات الحالية',
          updateFailed: 'تعذر تحديث التسعير',
          validateFailed: 'تعذر اعتماد العرض',
          rejectFailed: 'تعذر رفض العرض'
        },
        statusLabels: {
          pending: 'قيد الانتظار',
          validated: 'معتمد',
          rejected: 'مرفوض'
        },
        yes: 'نعم',
        no: 'لا',
        notSpecified: 'غير محدد'
      }
    }
  }
};
